import { writable } from 'svelte/store';

export const unbxdConfigdata: any = writable({});
